import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IframeModalService } from '../../../services/general/fullscreen.service';

@Component({
  selector: 'app-full-screen-iframe',
  templateUrl: './full-screen-iframe.component.html',
  styleUrls: ['./full-screen-iframe.component.css']
})
export class FullScreenIframeComponent implements OnInit {
  @Input() iframeUrl: string;
  safeUrl: SafeResourceUrl;

  constructor(
    private iframeModalService: IframeModalService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);
  }

  closeIframe(): void {
    this.iframeModalService.close();
  }
}


// WEBPACK FOOTER //
// /app/src/app/components/utils/fullscreen/full-screen-iframe.component.ts